import { render, staticRenderFns } from "./delaccount.vue?vue&type=template&id=4285de30&scoped=true"
import script from "./delaccount.vue?vue&type=script&lang=js"
export * from "./delaccount.vue?vue&type=script&lang=js"
import style0 from "./delaccount.vue?vue&type=style&index=0&id=4285de30&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4285de30",
  null
  
)

export default component.exports